import { Lookup } from '../lookup.interface';
export const ClientReceivedServices: { [name: string]: Lookup } = {
  ceis: { displayValue: 'CEIS ', code: 'ceis' },
  dres: { displayValue: 'DRES ', code: 'dres' },
  etw: { displayValue: 'ETW Project', code: 'etw' },
  nap: { displayValue: 'Negotiated Accountability Plan (NAP)', code: 'nap' },
};
